// extracted by mini-css-extract-plugin
export default {"form__group":"customInput_form__group__+xpfa","form__field":"customInput_form__field__UJjJ+","form__label":"customInput_form__label__0ypqs"};